import { render, staticRenderFns } from "./SidebarToggleButton.vue?vue&type=template&id=0b134f1a"
import script from "./SidebarToggleButton.vue?vue&type=script&lang=js"
export * from "./SidebarToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports